<template>
  <lt-ui-form contendPadding="0px" style="border-width: 0px;">
    <el-form ref="form" :model="form" label-width="60px">
      <el-row>
        <el-col>
          <el-form-item label="填充色">
            <el-color-picker
              v-model="form.fillColor"
              size="mini"
            ></el-color-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="渐变色">
            <el-color-picker
              v-model="form.gradientColor"
              size="mini"
            ></el-color-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="渐变方向">
            <el-select v-model="form.direct" style="width: 238px;">
              <el-option key="north" label="北" value="north"></el-option>
              <el-option key="south" label="南" value="south"></el-option>
              <el-option key="east" label="东" value="east"></el-option>
              <el-option key="west" label="西" value="west"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="线条颜色">
            <el-color-picker
              v-model="form.lineColor"
              size="mini"
            ></el-color-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="线型">
            <el-select v-model="form.lineType" style="width: 238px;">
              <el-option :key="1" label="—————————————————" :value="1">
                <el-image
                  style="width: 238px; height: 2px;"
                  :src="imageURL"
                  fit="fill"
                ></el-image>
              </el-option>
              <el-option
                :key="2"
                label="---------------------------------------------------"
                :value="2"
              >
                <el-image
                  style="width: 238px; height: 2px;"
                  :src="imageURL1"
                  fit="fill"
                ></el-image>
              </el-option>
              <el-option
                :key="3"
                label="..............................................................."
                :value="3"
              >
                <el-image
                  style="width: 238px; height: 2px;"
                  :src="imageURL2"
                  fit="fill"
                ></el-image>
              </el-option>
              <el-option
                :key="4"
                label=". . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . ."
                :value="4"
              >
                <el-image
                  style="width: 238px; height: 2px;"
                  :src="imageURL3"
                  fit="fill"
                ></el-image>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="线宽(pt)" prop="strokeWidth">
            <el-input v-model="form.strokeWidth">
              <el-button
                slot="prepend"
                icon="icon icon-minus green"
                @click="handleLDesc"
              ></el-button>
              <el-button
                slot="append"
                icon="icon icon-plus green"
                @click="handleLIncrese"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="透明度(%)" prop="opacity">
            <el-input v-model="form.opacity">
              <el-button
                slot="prepend"
                icon="icon icon-minus green"
                @click="handleOpacDesc"
              ></el-button>
              <el-button
                slot="append"
                icon="icon icon-plus green"
                @click="handleOpacIncrese"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="显示效果">
            <el-checkbox v-model="form.shadow">阴影</el-checkbox>
            <el-checkbox v-model="form.glass">玻璃特效</el-checkbox>
            <el-checkbox v-model="form.rounded">圆角特效</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="背景图片">
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                alt
                v-if="form.imageUrl"
                :src="form.imageUrl"
                class="avatar"
                style="width: 20px; height: 20px;"
              />
              <em v-else class="el-icon-plus avatar-uploader-icon"></em>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="showEditStyle == false">
        <el-button
          size="mini"
          icon=" icon icon-edit green"
          @click="handleeditStyle"
          style="margin-left: 100px; margin-top: 5px; margin-bottom: 5px;"
          >样式编辑</el-button
        >
      </el-row>
      <el-row v-else>
        <el-row>
          <el-input
            type="textarea"
            :rows="6"
            v-model="form.editStyle"
          ></el-input>
        </el-row>
        <el-row>
          <el-button
            size="mini"
            icon=" icon icon-check green"
            @click="handleConfirm"
            style="margin-left: 70px; margin-top: 5px; margin-bottom: 5px;"
            >确认</el-button
          >
          <el-button
            size="mini"
            icon=" icon icon-times red"
            @click="handleCancel"
            >取消</el-button
          >
        </el-row>
      </el-row>
    </el-form>
  </lt-ui-form>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      default() {
        return null;
      },
    },
    ifChange: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {
        fillColor: "#FFFFFF", //填充色
        gradientColor: "#FFFFFF", //渐变色
        direct: "north", //渐变方向
        lineColor: "#000000", //边框颜色
        lineType: 1, //线型
        strokeWidth: 0, //线宽
        opacity: 100, //透明度
        shadow: false, //是否显示阴影
        glass: false, //玻璃特效
        rounded: false, //圆角特效
        editStyle: "", //样式
        imageUrl: "", //图片背景色
        cellType: "", //元素类别
      },
      showEditStyle: false,
      originStyle: "", //原始样式
      imageURL:
        this.getProfileBaseUrlInfo() + "mxgraph-source/images/images/line.png",
      imageURL1:
        this.getProfileBaseUrlInfo() + "mxgraph-source/images/images/line1.png",
      imageURL2:
        this.getProfileBaseUrlInfo() + "mxgraph-source/images/images/line2.png",
      imageURL3:
        this.getProfileBaseUrlInfo() + "mxgraph-source/images/images/line3.png",
    };
  },
  watch: {
    formData: function (newValue) {
      if (newValue != null && newValue != undefined) {
        if (newValue.target.cellType != undefined) {
          var state = newValue.parent.getView().getState(newValue.target);
          var shape = state.shape;
          if (
            newValue.target.cellType == "fx" ||
            newValue.target.cellType == "text"
          ) {
            shape.strokewidth = 0;
          }
          this.form.fillColor = shape.fill;
          this.form.gradientColor = shape.gradient;
          this.form.direct = shape.direction;
          this.form.lineColor = shape.stroke;
          this.form.lineType = this.getLineType(state.style); //shape.isDashed == false ? 1 : 2;
          this.form.strokeWidth = shape.strokewidth;
          this.form.opacity = shape.opacity;
          this.form.shadow = shape.isShadow;
          this.form.glass = shape.glass;
          this.form.rounded = shape.isRounded;
          this.form.cellType =
            newValue.target.cellType == undefined
              ? ""
              : newValue.target.cellType;
          this.form.editStyle = newValue.target.style;
        }
      }
    },
    form: {
      handler: function (newVal, oldVal) {
        var propertyData = {
          data: newVal,
          type: "Style",
        };
        if (this.ifChange) {
          return;
        }

        this.$emit("StyleChange", propertyData);
      },
      deep: true,
    },
  },
  methods: {
    beforeAvatarUpload(file) {
      //文件上传检查
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleAvatarSuccess(res, file) {
      //文件上传成功
      this.form.imageUrl = URL.createObjectURL(file.raw);
    },
    getLineType(style) {
      //根据样式返回线条样式
      if (style.dashed == 0 || style.dashed == undefined) {
        return 1;
      } else if (style.dashed == 1) {
        if (style.dashPattern == "1 1") {
          return 2;
        }
        if (style.dashPattern == "1 2") {
          return 3;
        }
        if (style.dashPattern == "1 4") {
          return 4;
        }
        //默认返回2
        return 2;
      }
    },
    getFormData() {
      //返回页面数据
      return this.form;
    },
    handleLDesc() {
      if (this.form.strokeWidth > 0) {
        this.form.strokeWidth--;
      }
    },
    handleLIncrese() {
      this.form.strokeWidth++;
    },
    handleOpacDesc() {
      if (this.form.opacity > 1) {
        this.form.opacity--;
      }
    },
    handleOpacIncrese() {
      if (this.form.opacity < 100) {
        this.form.opacity++;
      }
    },
    handleeditStyle() {
      this.showEditStyle = true;
    },
    handleConfirm() {
      this.showEditStyle = false;
      var propertyData = {
        data: this.form.editStyle,
        type: "EditStyle",
      };
      this.$emit("StyleChange", propertyData);
    },
    handleCancel() {
      this.showEditStyle = false;
      // this.form.editStyle = "";
    },
  },
};
</script>
